import { CommonModule } from '@angular/common';
import { Component, computed, effect, input, signal, ChangeDetectionStrategy } from '@angular/core';

import { IFiltredDashboardResponse } from '@app/shared/interfaces/dashboard.interface';

import { ProgressSpinner } from 'primeng/progressspinner';

@Component({
    selector: 'app-doughnut-chart',
    imports: [CommonModule, ProgressSpinner],
    templateUrl: './doughnut-chart.component.html',
    styleUrl: './doughnut-chart.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DoughnutChartComponent {
    loading = input<boolean>(false);
    salesChannelData = input<IFiltredDashboardResponse['salesChannel']['total']>();

    readonly admin = computed(() => Number(this.salesChannelData()?.admin) || 0);
    readonly ota = computed(() => Number(this.salesChannelData()?.ota) || 0);
    readonly ibe = computed(() => Number(this.salesChannelData()?.ibe) || 0);

    readonly totalSales = computed(() => this.admin() + this.ota() + this.ibe());

    readonly adminPct = computed(() => this.totalSales() ? (this.admin() / this.totalSales()) * 100 : 0);
    readonly otaPct = computed(() => this.totalSales() ? (this.ota() / this.totalSales()) * 100 : 0);
    readonly ibePct = computed(() => this.totalSales() ? (this.ibe() / this.totalSales()) * 100 : 0);

    readonly conicGradient = computed(() => {
        const adminEnd = this.adminPct();
        const otaEnd = adminEnd + this.otaPct();
        return `conic-gradient(#4c68df 0 ${adminEnd}%, #25a9a2 ${adminEnd}% ${otaEnd}%, #a8dbd5 ${otaEnd}% 100%)`;
    });
}
